import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { INACTIVITY_CONFIG } from '../components/config/inactivityConfig';
import SignatureCanvas from 'react-signature-canvas';
import config from '../config';

const LoginPage = () => {
  const location = useLocation();
  const [isLogin, setIsLogin] = React.useState(true);
  const [showForgotPassword, setShowForgotPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');  const [formData, setFormData] = React.useState({
    email: '',
    password: '',
    mt5_account: '',
    acceptedTerms: false,
    orderFormSigned: false,
    broker_name: "Swissquote",
    broker_server: "Swissquote-Instit-Server"
  });

  // Forgot password form data
  const [forgotPasswordData, setForgotPasswordData] = React.useState({
    email: '',
    mt5_account: ''
  });

  // Order form modal states
  const [showOrderForm, setShowOrderForm] = React.useState(false);
  const [orderFormLanguage, setOrderFormLanguage] = React.useState('en');
  const [entityType, setEntityType] = React.useState('private'); // 'private' or 'company'
  const [customerInfo, setCustomerInfo] = React.useState({
    // Private entity fields
    fullName: '',
    address: '',
    mothersMaidenName: '',
    dateOfBirth: '',
    // Company fields
    companyName: '',
    registeredOffice: '',
    companyRegNumber: '',
    taxIdNumber: '',
    representative: ''
  });
  const [signatureData, setSignatureData] = React.useState('');
  const signatureRef = useRef();

  // Check for inactivity logout reason in URL parameters
  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const reason = searchParams.get('reason');
    
    if (reason === 'inactivity') {
      setError(INACTIVITY_CONFIG.MESSAGES.LOGIN_MESSAGE);
    }
  }, [location]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
      // For registration, ensure terms and order form are accepted
    if (!isLogin && !formData.acceptedTerms) {
      setError('You must accept the Terms and Conditions to register');
      setLoading(false);
      return;
    }    if (!isLogin && !formData.orderFormSigned) {
      setError('You must sign the Order Form to register');
      setLoading(false);
      return;
    }

    try {
      if (isLogin) {
        // Login request
        const formBody = new URLSearchParams();
        formBody.append('username', formData.email);
        formBody.append('password', formData.password);

        const response = await fetch('https://starcopy.online/api/token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: formBody
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.detail || 'Authentication failed');
        }

        // Store token and admin status
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('isAdmin', data.is_admin || false);

        // Redirect based on admin status
        window.location.href = data.is_admin ? '/admin/dashboard' : '/';      } else {        // Registration request
        console.log("Sending registration data:", {
          email: formData.email,
          password: "[REDACTED]",
          mt5_account: formData.mt5_account,
          broker_name: formData.broker_name,
          broker_server: formData.broker_server,
          acceptedTerms: Boolean(formData.acceptedTerms)
        });
          // Prepare the registration data - with client-side validation
        if (!formData.email || !formData.email.includes('@')) {
          throw new Error("Please provide a valid email address");
        }
        
        if (!formData.password || formData.password.length < 6) {
          throw new Error("Password must be at least 6 characters long");
        }
        
        if (!formData.mt5_account || formData.mt5_account.trim() === '') {
          throw new Error("MT5 Account Number is required");
        }
        
        // Prepare user data according to the server's schema requirements
        const registrationData = {
          email: formData.email.trim(),
          password: formData.password,
          mt5_account: formData.mt5_account.trim(),
          broker_name: formData.broker_name || "Swissquote",
          broker_server: formData.broker_server || "Swissquote-Instit-Server",
          acceptedTerms: Boolean(formData.acceptedTerms)  // Ensure this is a proper boolean
        };
        
        console.log("Final registration payload:", {
          ...registrationData,
          password: "[REDACTED]"
        });// Use the registration data we prepared earlier and send directly to the API endpoint
        let response;
          
        try {
          // Use the api/register endpoint with the properly formatted data
          console.log("Trying registration with correct API endpoint");
          
          // Create the request body matching exactly what the API expects
          const cleanPayload = {
            "email": formData.email.trim(),
            "password": formData.password,
            "mt5_account": formData.mt5_account.trim(),
            "broker_name": formData.broker_name || "Swissquote",
            "broker_server": formData.broker_server || "Swissquote-Instit-Server",
            "acceptedTerms": true // Literal boolean true, not wrapped in quotes
          };
          
          console.log("Using cleaned payload:", {...cleanPayload, password: "[REDACTED]"});
          
          // Make sure there are no whitespace or formatting issues in the JSON
          const stringifiedPayload = JSON.stringify(cleanPayload);
          console.log("Stringified payload:", stringifiedPayload);
          
          // Use the correct API endpoint with /api prefix          // First try: POST to /api/register
          try {
            response = await fetch('https://starcopy.online/api/register', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: stringifiedPayload
            });
            
            console.log(`First attempt (POST /api/register) returned status: ${response.status}`);
            
            // If POST to /api/register fails with method not allowed, try PUT
            if (response.status === 405) {
              console.log("POST method not allowed, trying PUT method");
              
              response = await fetch('https://starcopy.online/api/register', {
                method: 'PUT',  // Try PUT instead of POST
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: stringifiedPayload
              });
              
              console.log(`PUT /api/register returned status: ${response.status}`);
            }
            
            // If API endpoint fails completely, try the legacy endpoint 
            if (response.status === 404 || response.status === 405) {
              console.log("API endpoint not found or method not allowed, trying legacy endpoint");
              
              response = await fetch('https://starcopy.online/register', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json', 
                  'Accept': 'application/json'
                },
                body: stringifiedPayload
              });
              
              console.log(`Legacy endpoint (POST /register) returned status: ${response.status}`);
              
              // Try PUT on legacy endpoint if POST fails
              if (response.status === 405) {
                console.log("POST to legacy endpoint failed, trying PUT");
                
                response = await fetch('https://starcopy.online/register', {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  }, 
                  body: stringifiedPayload
                });
                
                console.log(`PUT /register returned status: ${response.status}`);
              }
            }
          } catch (fetchError) {
            console.error("Error during fetch attempts:", fetchError);
          }
          
          // If JSON fails with validation error, try form-urlencoded as a last resort
          if (response.status === 422 || response.status === 405 || response.status === 400) {
            console.log(`JSON format failed with status ${response.status}, trying form-urlencoded`);
            
            // Convert to form-urlencoded format
            const formBody = new URLSearchParams();
            formBody.append('email', formData.email.trim());
            formBody.append('password', formData.password);
            formBody.append('mt5_account', formData.mt5_account.trim());
            formBody.append('broker_name', formData.broker_name || "Swissquote");
            formBody.append('broker_server', formData.broker_server || "Swissquote-Instit-Server");
            formBody.append('acceptedTerms', 'true'); // Use string 'true' for form encoding
              // Try all possible combinations for form-urlencoded
            console.log("Trying form-urlencoded with multiple methods and endpoints");
            
            // Array of attempts to try
            const attempts = [
              { endpoint: 'https://starcopy.online/api/register', method: 'POST' },
              { endpoint: 'https://starcopy.online/api/register', method: 'PUT' },
              { endpoint: 'https://starcopy.online/register', method: 'POST' },
              { endpoint: 'https://starcopy.online/register', method: 'PUT' }
            ];
            
            // Try each attempt until one succeeds or all fail
            for (const attempt of attempts) {
              try {
                console.log(`Trying ${attempt.method} to ${attempt.endpoint} with form-urlencoded`);
                
                response = await fetch(attempt.endpoint, {
                  method: attempt.method,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  body: formBody
                });
                
                console.log(`${attempt.method} ${attempt.endpoint} returned status: ${response.status}`);
                
                // If this attempt succeeded or returned a non-404/405 error, stop trying
                if (response.status !== 404 && response.status !== 405) {
                  console.log(`Stopping attempts at ${attempt.method} ${attempt.endpoint} with status ${response.status}`);
                  break;
                }
              } catch (attemptError) {
                console.error(`Error with ${attempt.method} ${attempt.endpoint}:`, attemptError);
              }
            }
            
            console.log(`Form-urlencoded approach returned status ${response.status}`);
          }        } catch (fetchError) {
          console.error("Fetch error:", fetchError);
          throw new Error(`Network error while trying to register: ${fetchError.message}`);
        }
        
        // Get raw response text first for debugging
        const rawText = await response.text();
        console.log("Raw response:", rawText);
        
        // Try to parse as JSON
        let data;
        try {
            data = JSON.parse(rawText);
        } catch (parseError) {
            console.error("Failed to parse response as JSON:", parseError);
            data = { detail: "Invalid server response" };
        }
        
        console.log("Registration response:", response.status, data);
        
        // Let's check all response headers
        console.log("Response headers:");
        response.headers.forEach((value, name) => {
            console.log(`${name}: ${value}`);
        });
        
        if (!response.ok) {
          // Get more details about the error
          let errorMessage;
            // Handle different error formats
          if (typeof data === 'object') {
            // Handle FastAPI validation error format
            if (data.detail && Array.isArray(data.detail)) {
              // This is likely a FastAPI validation error with detailed info
              errorMessage = data.detail.map(err => {
                if (err.loc && Array.isArray(err.loc)) {
                  // If it's a body validation error about the root structure
                  if (err.loc.includes('body') && err.msg.includes('valid dictionary')) {
                    return `API validation error: The server expects a simple JSON object. This is likely a format issue.`;
                  }
                  // Normal field validation error
                  return `Field '${err.loc[err.loc.length-1]}': ${err.msg}`;
                }
                return err.msg || 'Validation error';
              }).join('; ');
            } else if (data.detail) {
              // Simple error message in detail field
              errorMessage = typeof data.detail === 'string' ? 
                data.detail : JSON.stringify(data.detail);
            } else if (data.message) {
              // Some APIs use message instead of detail
              errorMessage = data.message;
            } else {
              // Unknown error format, stringify it
              try {
                errorMessage = JSON.stringify(data);
              } catch (e) {
                errorMessage = "Unknown error format";
              }
            }
          } else {
            errorMessage = `Registration failed with status ${response.status}`;
          }
          
          console.error("Registration error details:", data);
          
          // Try to extract validation errors if they exist
          if (data.validation_error || data.detail) {
            console.log("Validation errors:", data.validation_error || data.detail);
          }
            // Try to provide more specific error messages
          if (data.detail && typeof data.detail === 'string' && data.detail.includes("Email already registered")) {
            // Instead of just showing an error, offer to add a new MT5 account
            if (window.confirm("This email is already registered. Would you like to add another MT5 account to your existing account?")) {
              console.log("Attempting to add MT5 account to existing user");
              
              try {
                // Use our new endpoint specifically for adding accounts to existing users
                const addAccountResponse = await fetch('https://starcopy.online/api/register-additional-account', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    email: formData.email.trim(),
                    password: formData.password,
                    mt5_account: formData.mt5_account.trim(),
                    broker_name: formData.broker_name,
                    broker_server: formData.broker_server,
                    acceptedTerms: true
                  })
                });
                
                const addAccountData = await addAccountResponse.json();
                
                if (addAccountResponse.ok) {
                  // Successfully added the account
                  setIsLogin(true);
                  setError("MT5 account added successfully! Please sign in to access your accounts.");
                  return;
                } else {
                  // Failed to add the account
                  errorMessage = addAccountData.detail || "Failed to add MT5 account. Please try again.";
                }
              } catch (addAccountError) {
                console.error("Error adding MT5 account:", addAccountError);
                errorMessage = "Error adding MT5 account: " + addAccountError.message;
              }
            } else {
              // User chose not to add another account
              errorMessage = "This email is already registered. Please use a different email or sign in.";
            }
          } else if (response.status === 400) {
            if (!errorMessage || errorMessage === '[object Object]') {
              errorMessage = `Registration failed: ${data.detail || 'Bad request - please check all fields'}`;
            }
          } else if (response.status === 405) {
            errorMessage = "Registration error: Method not allowed. Please try again.";
          } else if (response.status === 422) {
            if (!errorMessage || errorMessage === '[object Object]') {
              errorMessage = "Registration failed: Data validation error. Please check all fields.";
            }
          }
          
          throw new Error(errorMessage);
        }

        setIsLogin(true);
        setError('Registration successful! Please login.');
        setFormData(prev => ({
          ...prev,
          password: ''
        }));
      }    } catch (err) {
      console.error("Request error:", err);
      
      // Provide more user-friendly error messages
      if (err.message.includes("Failed to fetch")) {
        setError("Network error - please check your internet connection and try again.");
      } else if (err.message.includes("TypeError")) {
        setError("Technical error - please try again later.");
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Handle forgot password request
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Validate input
      if (!forgotPasswordData.email || !forgotPasswordData.email.includes('@')) {
        throw new Error("Please provide a valid email address");
      }

      if (!forgotPasswordData.mt5_account || forgotPasswordData.mt5_account.trim() === '') {
        throw new Error("MT5 Account Number is required for verification");
      }

      const resetData = {
        email: forgotPasswordData.email.trim(),
        mt5_account: forgotPasswordData.mt5_account.trim()
      };

      console.log("Sending password reset request:", resetData);

      const response = await fetch('https://starcopy.online/api/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(resetData)
      });

      const data = await response.json();
      console.log("Forgot password response:", response.status, data);

      if (!response.ok) {
        let errorMessage = data.detail || "Failed to process password reset request";
        
        if (response.status === 404) {
          errorMessage = "No account found with this email and MT5 account combination";
        } else if (response.status === 400) {
          errorMessage = "Invalid email or MT5 account number";
        }
        
        throw new Error(errorMessage);
      }

      setSuccess("Password reset instructions have been sent to your email address. Please check your inbox and spam folder.");
      setForgotPasswordData({ email: '', mt5_account: '' });
      
      // Auto-switch back to login after 3 seconds
      setTimeout(() => {
        setShowForgotPassword(false);
        setSuccess('');
      }, 3000);

    } catch (err) {
      console.error("Forgot password error:", err);
      setError(err.message || "Failed to process password reset request");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleForgotPasswordChange = (e) => {
    const { name, value } = e.target;
    setForgotPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };  const handleTermsChange = (e) => {
    setFormData(prev => ({
      ...prev,
      acceptedTerms: e.target.checked
    }));  };

  const handleCustomerInfoChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignatureEnd = () => {
    captureSignature();
  };
  const captureSignature = () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      setSignatureData(signatureRef.current.toDataURL());
    }
  };
  const clearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      setSignatureData('');
    }
  };
  const isOrderFormComplete = () => {
    if (!signatureData) return false;
    
    if (entityType === 'private') {
      return customerInfo.fullName.trim() && 
             customerInfo.address.trim() && 
             customerInfo.mothersMaidenName.trim() && 
             customerInfo.dateOfBirth.trim();
    } else {
      return customerInfo.companyName.trim() && 
             customerInfo.registeredOffice.trim() && 
             customerInfo.companyRegNumber.trim() && 
             customerInfo.taxIdNumber.trim() && 
             customerInfo.representative.trim();
    }
  };
  const getFieldClassName = (fieldValue) => {
    const baseClass = "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500";
    const emptyClass = "border-red-300 bg-red-50";
    const normalClass = "border-gray-300";
    
    return `${baseClass} ${fieldValue.trim() ? normalClass : emptyClass}`;
  };
  const isRegistrationFormValid = () => {
    const isValid = formData.email.trim() && 
           formData.password.trim() && 
           formData.mt5_account.trim() && 
           formData.acceptedTerms && 
           formData.orderFormSigned;
    
    // Debug logging
    console.log('Registration form validation:', {
      email: formData.email.trim(),
      password: formData.password.trim(),
      mt5_account: formData.mt5_account.trim(),
      acceptedTerms: formData.acceptedTerms,
      orderFormSigned: formData.orderFormSigned,
      isValid: isValid
    });
    
    return isValid;
  };  const saveOrderFormSignature = async () => {
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      alert(orderFormLanguage === 'en' ? 'Please provide your signature before submitting.' : 'Kérjük, írja alá a dokumentumot a beküldés előtt.');
      return;
    }
    if (!signatureData) {
      captureSignature();
    }

    // Validate all required fields based on entity type
    let missingFields = [];
    
    if (entityType === 'private') {
      if (!customerInfo.fullName.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Full Name' : 'Teljes név');
      if (!customerInfo.address.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Address' : 'Cím');
      if (!customerInfo.mothersMaidenName.trim()) missingFields.push(orderFormLanguage === 'en' ? "Mother's Maiden Name" : 'Anyja leánykori neve');
      if (!customerInfo.dateOfBirth.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Date of Birth' : 'Születési dátum');
    } else {
      if (!customerInfo.companyName.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Company Name' : 'Cégnév');
      if (!customerInfo.registeredOffice.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Registered Office' : 'Székhely');
      if (!customerInfo.companyRegNumber.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Company Registration Number' : 'Cégjegyzékszám');
      if (!customerInfo.taxIdNumber.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Tax ID Number' : 'Adószám');
      if (!customerInfo.representative.trim()) missingFields.push(orderFormLanguage === 'en' ? 'Representative' : 'Képviselő');
    }

    if (missingFields.length > 0) {
      const message = orderFormLanguage === 'en' 
        ? `Please fill out the following required fields: ${missingFields.join(', ')}`
        : `Kérjük, töltse ki a következő kötelező mezőket: ${missingFields.join(', ')}`;
      alert(message);
      return;
    }

    // Fill customer info with registration data based on entity type
    const orderFormData = {
      entityType,
      customerInfo,
      email: formData.email,
      mt5_account: formData.mt5_account,
      signature: signatureData,
      language: orderFormLanguage,
      timestamp: new Date().toISOString()
    };

    try {
      // Generate PDF/image of the signed order form
      const response = await fetch(`${config.apiUrl}/save-order-form`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderFormData)
      });

      if (response.ok) {
        setFormData(prev => ({ ...prev, orderFormSigned: true }));
        setShowOrderForm(false);
        const successMessage = orderFormLanguage === 'en' 
          ? 'Order form signed and saved successfully!'
          : 'Megrendelőlap sikeresen aláírva és elmentve!';
        alert(successMessage);
      } else {
        const errorData = await response.json().catch(() => ({}));
        const serverDetail = errorData.detail || '';
        const errorMessage = serverDetail
          ? `Error: ${serverDetail}`
          : (orderFormLanguage === 'en' 
              ? 'Failed to save order form. Please try again.'
              : 'Nem sikerült elmenteni a megrendelőlapot. Kérjük, próbálja újra.');
        alert(errorMessage);
      }
    } catch (error) {
      console.error('Error saving order form:', error);
      const errorMessage = orderFormLanguage === 'en' 
        ? 'Error saving order form. Please try again.'
        : 'Hiba történt a megrendelőlap mentése során. Kérjük, próbálja újra.';
      alert(errorMessage);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-center text-3xl font-bold text-gray-900">
          {isLogin ? 'Sign in to your account' : 'Create a new account'}
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {error && (
            <div className="mb-4 p-4 rounded-md bg-red-50 text-red-700">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-4 rounded-md bg-green-50 text-green-700">
              {success}
            </div>
          )}

          {/* Show forgot password form */}
          {showForgotPassword ? (
            <form onSubmit={handleForgotPassword} className="space-y-6">
              <div>
                <label htmlFor="forgot-email" className="block text-sm font-medium text-gray-700">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="forgot-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={forgotPasswordData.email}
                    onChange={handleForgotPasswordChange}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter your email address"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="forgot-mt5" className="block text-sm font-medium text-gray-700">
                  MT5 Account Number
                </label>
                <div className="mt-1">
                  <input
                    id="forgot-mt5"
                    name="mt5_account"
                    type="text"
                    required
                    value={forgotPasswordData.mt5_account}
                    onChange={handleForgotPasswordChange}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter your MT5 account number"
                  />
                </div>
                <p className="mt-1 text-xs text-gray-500">
                  We need your MT5 account number to verify your identity
                </p>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                >
                  {loading ? 'Sending Reset Link...' : 'Send Reset Link'}
                </button>
              </div>
            </form>
          ) : (
            /* Regular login/register form */
            <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className={!isLogin ? getFieldClassName(formData.email) : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"}
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="mt-1">                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete={isLogin ? "current-password" : "new-password"}
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className={!isLogin ? getFieldClassName(formData.password) : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"}
                />
              </div>
            </div>            {!isLogin && (
              <>
                <div>
                  <label htmlFor="mt5_account" className="block text-sm font-medium text-gray-700">
                    MT5 Account Number
                  </label>
                  <div className="mt-1">                    <input
                      id="mt5_account"
                      name="mt5_account"
                      type="text"
                      required
                      value={formData.mt5_account}
                      onChange={handleChange}
                      className={getFieldClassName(formData.mt5_account)}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="broker_name" className="block text-sm font-medium text-gray-700">
                    Broker Name
                  </label>
                  <div className="mt-1">
                    <select
                      id="broker_name"
                      name="broker_name"
                      required
                      value={formData.broker_name}
                      onChange={handleChange}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="Swissquote">Swissquote</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label htmlFor="broker_server" className="block text-sm font-medium text-gray-700">
                    Broker Server
                  </label>
                  <div className="mt-1">
                    <select
                      id="broker_server"
                      name="broker_server"
                      required
                      value={formData.broker_server}
                      onChange={handleChange}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="Swissquote-Instit-Server">Swissquote Institution Server</option>
                      <option value="Swissquote-Live-Server">Swissquote Live Server</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </>
            )}
            {!isLogin && (
              <>
                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="terms"
                      name="terms"
                      type="checkbox"
                      checked={formData.acceptedTerms}
                      onChange={handleTermsChange}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      required
                    />
                  </div>                  <div className="ml-3 text-sm">
                    <label htmlFor="terms" className="font-medium text-gray-700">
                      I accept the Terms and Conditions:{' '}
                      <a
                        href="/Software Licensing Agreement Starcopy EN.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-500 mr-2"
                      >
                        EN
                      </a>
                      |
                      <a
                        href="/Szoftver licencia Starcopy HU.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-500 ml-2"
                      >
                        HU
                      </a>
                    </label>
                  </div>                </div>

                {/* Order Form Button */}
                <div className="mt-4">
                  <button
                    type="button"
                    onClick={() => setShowOrderForm(true)}
                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium ${
                      formData.orderFormSigned
                        ? 'bg-green-600 text-white cursor-default'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                    disabled={formData.orderFormSigned}
                  >
                    {formData.orderFormSigned 
                      ? '✓ Order Form Signed / Megrendelőlap aláírva'
                      : 'Sign Order Form / Megrendelőlap aláírása'
                    }
                  </button>
                </div>
              </>
            )}            <div className="space-y-3">
              {/* Only show Register button when all requirements are met for registration */}
              {isLogin || isRegistrationFormValid() ? (
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                >
                  {loading ? 'Please wait...' : (isLogin ? 'Sign in' : 'Register')}
                </button>
              ) : (
                <div className="w-full py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-500 bg-gray-100 text-center">
                  {!formData.email.trim() 
                    ? 'Please enter your email address'
                    : !formData.password.trim()
                    ? 'Please enter a password'
                    : !formData.mt5_account.trim()
                    ? 'Please enter your MT5 Account Number'
                    : !formData.acceptedTerms 
                    ? 'Please accept Terms and Conditions'
                    : !formData.orderFormSigned
                    ? 'Please sign the Order Form'
                    : 'Please complete all required fields'
                  }
                </div>
              )}
            </div>
          </form>
          )}

          <div className="mt-6">
            {showForgotPassword ? (
              <div className="space-y-2">
                <button
                  onClick={() => {
                    setShowForgotPassword(false);
                    setError('');
                    setSuccess('');
                    setForgotPasswordData({ email: '', mt5_account: '' });
                  }}
                  className="w-full text-center text-sm text-blue-600 hover:text-blue-500"
                >
                  Back to Login
                </button>
              </div>
            ) : (
              <div className="space-y-2">
                {isLogin && (
                  <button
                    onClick={() => {
                      setShowForgotPassword(true);
                      setError('');
                      setSuccess('');
                    }}
                    className="w-full text-center text-sm text-blue-600 hover:text-blue-500"
                  >
                    Forgot your password?
                  </button>
                )}
                <button
                  onClick={() => {
                    setIsLogin(!isLogin);
                    setError('');
                    setSuccess('');
                    setFormData({
                      email: '',
                      password: '',
                      mt5_account: '',
                      acceptedTerms: false,
                      orderFormSigned: false,
                      broker_name: "Swissquote",
                      broker_server: "Swissquote-Instit-Server"
                    });
                  }}
                  className="w-full text-center text-sm text-blue-600 hover:text-blue-500"
                >
                  {isLogin ? 'Need an account? Register' : 'Already have an account? Sign in'}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Order Form Modal */}
      {showOrderForm && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              {/* Modal Header */}
              <div className="flex justify-between items-center pb-3 mb-4 border-b">
                <h3 className="text-lg font-bold text-gray-900">
                  Order Form / Megrendelőlap
                </h3>
                <button
                  onClick={() => setShowOrderForm(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              {/* Language Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Language / Válassza ki a nyelvet:
                </label>
                <div className="flex space-x-4">
                  <button
                    onClick={() => setOrderFormLanguage('en')}
                    className={`px-4 py-2 rounded ${
                      orderFormLanguage === 'en'
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    English
                  </button>
                  <button
                    onClick={() => setOrderFormLanguage('hu')}
                    className={`px-4 py-2 rounded ${
                      orderFormLanguage === 'hu'
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    Magyar
                  </button>
                </div>
              </div>              {/* Customer Information Form */}
              <div className="mb-6">
                <h4 className="text-md font-semibold text-gray-800 mb-3">
                  {orderFormLanguage === 'en' ? 'Customer Information' : 'Ügyfél adatok'}
                </h4>
                
                {/* Entity Type Selection */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {orderFormLanguage === 'en' ? 'Entity Type:' : 'Entitás típusa:'}
                  </label>
                  <div className="flex space-x-4">
                    <button
                      type="button"
                      onClick={() => setEntityType('private')}
                      className={`px-4 py-2 rounded ${
                        entityType === 'private'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {orderFormLanguage === 'en' ? 'Private Person' : 'Magánszemély'}
                    </button>
                    <button
                      type="button"
                      onClick={() => setEntityType('company')}
                      className={`px-4 py-2 rounded ${
                        entityType === 'company'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {orderFormLanguage === 'en' ? 'Company' : 'Cég'}
                    </button>
                  </div>
                </div>                {/* Form Fields based on Entity Type */}
                <div className="grid grid-cols-1 gap-4">
                  {entityType === 'private' ? (
                    <>
                      <input
                        type="text"
                        name="fullName"
                        placeholder={orderFormLanguage === 'en' ? 'Full Name *' : 'Teljes név *'}
                        value={customerInfo.fullName}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.fullName)}
                        required
                      />
                      <input
                        type="text"
                        name="address"
                        placeholder={orderFormLanguage === 'en' ? 'Address *' : 'Cím *'}
                        value={customerInfo.address}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.address)}
                        required
                      />
                      <input
                        type="text"
                        name="mothersMaidenName"
                        placeholder={orderFormLanguage === 'en' ? "Mother's Maiden Name *" : 'Anyja leánykori neve *'}
                        value={customerInfo.mothersMaidenName}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.mothersMaidenName)}
                        required
                      />
                      <input
                        type="date"
                        name="dateOfBirth"
                        placeholder={orderFormLanguage === 'en' ? 'Date of Birth *' : 'Születési dátum *'}
                        value={customerInfo.dateOfBirth}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.dateOfBirth)}
                        required
                      />
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        name="companyName"
                        placeholder={orderFormLanguage === 'en' ? 'Company Name *' : 'Cégnév *'}
                        value={customerInfo.companyName}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.companyName)}
                        required
                      />
                      <input
                        type="text"
                        name="registeredOffice"
                        placeholder={orderFormLanguage === 'en' ? 'Registered Office *' : 'Székhely *'}
                        value={customerInfo.registeredOffice}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.registeredOffice)}
                        required
                      />
                      <input
                        type="text"
                        name="companyRegNumber"
                        placeholder={orderFormLanguage === 'en' ? 'Company Registration Number *' : 'Cégjegyzékszám *'}
                        value={customerInfo.companyRegNumber}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.companyRegNumber)}
                        required
                      />
                      <input
                        type="text"
                        name="taxIdNumber"
                        placeholder={orderFormLanguage === 'en' ? 'Tax ID Number *' : 'Adószám *'}
                        value={customerInfo.taxIdNumber}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.taxIdNumber)}
                        required
                      />
                      <input
                        type="text"
                        name="representative"
                        placeholder={orderFormLanguage === 'en' ? 'Representative *' : 'Képviselő *'}
                        value={customerInfo.representative}
                        onChange={handleCustomerInfoChange}
                        className={getFieldClassName(customerInfo.representative)}
                        required
                      />                    </>
                  )}
                </div>
                
                {/* Required fields note */}
                <p className="text-xs text-gray-500 mt-2">
                  * {orderFormLanguage === 'en' ? 'Required fields' : 'Kötelező mezők'}
                </p>
              </div>{/* Order Form Content */}
              <div className="mb-6 p-4 bg-gray-50 rounded-md max-h-64 overflow-y-auto">
                <div className="text-sm text-gray-700">
                  {orderFormLanguage === 'en' ? (
                    <div>
                      <h4 className="font-bold mb-2">Order form</h4>
                      <p className="mb-2">
                        The undersigned [
                        {entityType === 'private' 
                          ? customerInfo.fullName || '[Full Name]'
                          : customerInfo.companyName || '[Company Name]'
                        }] (
                        {entityType === 'private' 
                          ? `address: [${customerInfo.address || '[Address]'}]; mother's maiden name: [${customerInfo.mothersMaidenName || '[Mother\'s Name]'}]; date of birth: [${customerInfo.dateOfBirth || '[Date of Birth]'}]`
                          : `registered office: [${customerInfo.registeredOffice || '[Registered Office]'}]; company registration number: [${customerInfo.companyRegNumber || '[Reg. Number]'}]; tax identification number: [${customerInfo.taxIdNumber || '[Tax ID]'}]; represented by: [${customerInfo.representative || '[Representative]'}]`
                        }; hereinafter referred to as the "Licensee"), 
                        by completing and accepting this Order Form, hereby orders the software named STARCOPY as defined in the GTC 
                        and its operational and maintenance services from HUNGAROGLOBE LTD (registered office: HUNGAROGLOBE LTD, 31291, 
                        Al Jazeera AlHamra,Ras Al Khaimah, UAE; registration number:AFZ/AIBCI096; represented by: Tibor Novak, 
                        Managing Director; hereinafter referred to as the "Licensor").
                      </p>
                      <p className="mb-2">
                        The subject of this Order is the provision of services by the Licensor with the content defined in the GTC, 
                        based on the provisions set forth in the GTC.
                      </p>
                      <p className="mb-2">
                        The amount and schedule of the License Fee payable under the Agreement are contained in the GTC, which the Licensee, 
                        by completing and electronically submitting this Order Form, also accepts as binding upon itself.
                      </p>
                      <p>
                        The Licensee, by completing and electronically submitting this Order Form, confirms and reiterates its express 
                        declaration that it has reviewed, electronically received, and expressly accepts as binding upon itself the GTC, 
                        the Privacy Policy (Data Processing Information), and other annexes to the Agreement.
                      </p>
                    </div>
                  ) : (
                    <div>
                      <h4 className="font-bold mb-2">MEGRENDELŐLAP</h4>
                      <p className="mb-2">
                        Alulírott [
                        {entityType === 'private' 
                          ? customerInfo.fullName || '[Teljes név]'
                          : customerInfo.companyName || '[Cégnév]'
                        }] (
                        {entityType === 'private' 
                          ? `lakcím: [${customerInfo.address || '[Cím]'}]; anyja leánykori neve: [${customerInfo.mothersMaidenName || '[Anyja neve]'}]; születési dátum: [${customerInfo.dateOfBirth || '[Születési dátum]'}]`
                          : `székhely: [${customerInfo.registeredOffice || '[Székhely]'}]; cégjegyzékszám: [${customerInfo.companyRegNumber || '[Cégjegyzékszám]'}]; adószám: [${customerInfo.taxIdNumber || '[Adószám]'}]; képviselő: [${customerInfo.representative || '[Képviselő]'}]`
                        }; a továbbiakban „Licencvevő") 
                        a jelen Megrendelőlap kitöltésével és elfogadásával ezúton megrendelem az ÁSZF-ben meghatározott 
                        STARCOPY elnevezésű szoftvert és annak üzemeltetési és karbantartási szolgáltatásait a HUNGAROGLOBE LTD 
                        (székhely: HUNGAROGLOBE LTD, 31291, Al Jazeera AlHamra,Ras Al Khaimah, UAE; nyilvántartási szám: AFZ/AIBCI096; 
                        képviseli: Tibor Novak ügyvezető; a továbbiakban „Licenciaadó") Licenciaadótól.
                      </p>
                      <p className="mb-2">
                        Jelen Megrendelés tárgya az ÁSZF-ben meghatározott tartalommal bíró szolgáltatások Licenciaadó általi nyújtása 
                        az ÁSZF-ben foglaltak alapján.
                      </p>
                      <p className="mb-2">
                        A Szerződés alapján fizetendő Licenciadíj mértékét és ütemezését az ÁSZF tartalmazza, amelyet Licencvevő 
                        a jelen Megrendelőlap kitöltésével és elektronikus benyújtásával is magára nézve kötelezőnek fogad el.
                      </p>
                      <p>
                        Licenciavevő a jelen Megrendelőlap kitöltésével és elektronikus benyújtásával megerősíti, és ismételten 
                        kifejezetten nyilatkozik arról, hogy az ÁSZF-et, az Adatkezelési Tájékoztatót és a Szerződés további 
                        mellékleteit megismerte, elektronikusan átvette és az abban foglaltakat magára nézve kötelező érvényűnek 
                        kifejezetten elfogadja.
                      </p>
                    </div>
                  )}
                </div>
              </div>              {/* Digital Signature */}
              <div className="mb-6">
                <h4 className="text-md font-semibold text-gray-800 mb-3">
                  {orderFormLanguage === 'en' ? 'Digital Signature *' : 'Digitális aláírás *'}
                </h4>
                <div className={`border rounded-md p-2 ${!signatureData ? 'border-red-300 bg-red-50' : 'border-gray-300'}`}>
                  <SignatureCanvas
                    ref={signatureRef}
                    canvasProps={{
                      width: 500,
                      height: 200,
                      className: 'signature-canvas border border-gray-200 rounded'
                    }}
                    onEnd={handleSignatureEnd}
                  />
                </div>
                <div className="mt-2 flex space-x-2">
                  <button
                    type="button"
                    onClick={clearSignature}
                    className="px-3 py-1 text-sm bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                  >
                    {orderFormLanguage === 'en' ? 'Clear' : 'Törlés'}
                  </button>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {orderFormLanguage === 'en' 
                    ? 'Please sign above using your mouse or finger on mobile devices.'
                    : 'Kérjük, írja alá fent az egérrel vagy mobilon az ujjával.'
                  }
                </p>
              </div>              {/* Action Buttons */}
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowOrderForm(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                >
                  {orderFormLanguage === 'en' ? 'Cancel' : 'Mégse'}
                </button>
                <button
                  type="button"
                  onClick={saveOrderFormSignature}
                  disabled={!isOrderFormComplete()}
                  className={`px-4 py-2 rounded ${
                    isOrderFormComplete()
                      ? 'bg-blue-600 text-white hover:bg-blue-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  {orderFormLanguage === 'en' ? 'Sign and Submit' : 'Aláírás és elküldés'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;